import { render, staticRenderFns } from "./AnnouncementManagement.vue?vue&type=template&id=0a8954d3&scoped=true"
import script from "./AnnouncementManagement.vue?vue&type=script&lang=js"
export * from "./AnnouncementManagement.vue?vue&type=script&lang=js"
import style0 from "./AnnouncementManagement.vue?vue&type=style&index=0&id=0a8954d3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8954d3",
  null
  
)

export default component.exports